/**
 * サーバーに置いた測定履歴の形。
 *
 * **取りに行く手続きとは別のファイルに置いている。** 取得は
 * [[history.client.ts]] にあり、`*.client.ts` はサーバービルドで
 * 空のモジュールに差し替えられる。そこに定数を置くと、SSR では
 * `undefined` になって画面が描けない。
 *
 * 2026-09-03 に `/tools/typing` が 500 になったのがこれで、
 * `EMPTY_HISTORY` を初期値にした useState が undefined を持ち、
 * `remote.points.length` で落ちていた。型は消えるので害が無いが、
 * 値は必ずこちら側に置く。
 */

export type TypingHistoryPoint = {
  /** JST の暦日 */
  date: string;
  effectiveKpm: number;
  sessions: number;
  bestTokens: number;
};

export type TypingHistoryRow = {
  id: string;
  mode: string;
  durationMs: number;
  effectiveKpm: number;
  accuracy: number;
  caught: number;
  escaped: number;
  blazing: number;
  earnedTokens: number;
  entryTokens: number;
  /** false ならグラフには出ないが、打った事実としては残っている */
  measured: boolean;
  reason?: string;
  recordedAt: string;
};

export type TypingHistory = {
  points: TypingHistoryPoint[];
  recent: TypingHistoryRow[];
  /**
   * 取りに行って失敗したか。
   *
   * **空の履歴と区別する。** 落ちているのを「まだ 1 回も打っていません」と
   * 同じ顔で出すと、止まっている状態が正常に見えて誰も気づかない
   */
  failed: boolean;
  /** ログインしていないだけ。失敗ではない */
  signedOut: boolean;
};

export const EMPTY_HISTORY: TypingHistory = {
  points: [],
  recent: [],
  failed: false,
  signedOut: false,
};
